import apiClient from './apiClient';
import { GET_ACCOMODATION_LIST_URL } from './apiUrl';

const getAccomodationListApi = () => {
  return apiClient.get(GET_ACCOMODATION_LIST_URL);
};

export default getAccomodationListApi;
